module.exports = __webpack_public_path__ + "img/domijn.e030c8a1.jpg";